import http from "./http-common";

class DischargeService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) =>
        key &&
        payload[key] !== undefined &&
        payload[key] !== null &&
        payload[key] !== ""
          ? key + "=" + payload[key]
          : ""
      )
      .filter(Boolean)
      .join("&");
  }

  /**
   * GET /dischargeSummary/byPatient/:patientId
   * or GET /dischargeSummary/byAdmission/:admissionId
   */
  getDischargeSummary(payload) {
    const qs = this.queryString(payload);
    return http.get(`/dischargeSummary?${qs}`);
  }

  getDischargeById(dischSummaryId) {
    return http.get(`/dischargeSummary/${dischSummaryId}`);
  }

  saveDischargeSummary(payload) {
    return http.post("/dischargeSummary", payload);
  }

  updateDischargeSummary(dischSummaryId, payload) {
    return http.put(`/dischargeSummary/${dischSummaryId}`, payload);
  }

  getDischargeTreatments(payload) {
    return http.get("/dischtreatmentmst/list/filter");
  }
}

export default new DischargeService();
